var defineProperty = require('../internals/object-define-property');

module.exports = function (target, name, descriptor) {
  return defineProperty.f(target, name, descriptor);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/define-built-in-accessor.js
// module id = KiZW
// module chunks = 15